import clsx from 'clsx';
import React from 'react';
import { observer } from 'mobx-react';
import { VideoSourceEnum } from 'api';
import { Loader } from 'components/Loader';
import useStyles from './VideosGallery.styles';
import { VideoPreview } from '../VideoPreview/VideoPreview';
import { CreativeVideo } from '../../../../../../types';
import { useVideoPreview } from '../../hooks/useVideoPreview';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { Button, Card, CardActions, CardContent, CardMedia, Checkbox, Typography } from '@material-ui/core';
import { useAsyncExtractVideo } from '../../hooks/useAsyncExtractVideo';
interface Props {
  data: CreativeVideo[];
  videoSource: VideoSourceEnum;
  isSelected: (video: CreativeVideo) => boolean;
  handleVideoSelect: (video: CreativeVideo, checked: boolean) => void;
}

export const VideosGallery: React.FC<Props> = observer(
  ({ data, videoSource, isSelected, handleVideoSelect }: Props) => {
    const classes = useStyles();
    const { openVideoPreview, handleCloseVideoPreview, handleOpenVideoPreview } = useVideoPreview();
    useAsyncExtractVideo();

    return (
      <div className={classes.Root}>
        {data
          .filter((video) => video.videoSource === videoSource)
          .map((video, index) => (
            <LazyLoadComponent key={index}>
              <Card className={clsx(classes.VideoCard, isSelected(video) ? classes.VideoCardSelected : null)}>
                <CardActions>
                  <Checkbox
                    size="small"
                    color="primary"
                    value={video.id}
                    name={`video-${video.id}`}
                    checked={isSelected(video)}
                    onChange={(_, checked: boolean) => handleVideoSelect(video, checked)}
                  />

                  <Button
                    size="small"
                    color="primary"
                    disabled={video.loading}
                    style={{ marginLeft: 'auto' }}
                    onClick={() => handleOpenVideoPreview(video.source)}
                  >
                    preview
                  </Button>
                </CardActions>
                {video.loading ? (
                  <Loader />
                ) : (
                  <CardMedia
                    component="img"
                    className={classes.Media}
                    image={video.picture ?? ''}
                    alt="keywee-creative-video"
                    onClick={() => handleVideoSelect(video, !isSelected(video))}
                  />
                )}
                <CardContent>
                  <Typography variant="subtitle2">{video.title}</Typography>
                </CardContent>
              </Card>
            </LazyLoadComponent>
          ))}

        {openVideoPreview && (
          <VideoPreview
            open={openVideoPreview.show}
            source={openVideoPreview.source}
            onClose={handleCloseVideoPreview}
          />
        )}
      </div>
    );
  }
);
